<template>
    <div class="DashboardList">
        <Table class="actions">
            <tr slot="head">
                <th v-for="column in columns" :key="column">{{ column }}</th>
                <th>Actions</th>
            </tr>
            <slot></slot>
        </Table>
        <div class="status">
            <Loading v-if="isLoading"/>
            <Button v-else-if="!isComplete" class="primary" @click="$emit('loadMore')">Load More</Button>
        </div>
    </div>
</template>

<script>
import Table from '@/components/Table';
import Loading from '@/components/Loading';

export default {
    name: 'DashboardList',

    components: { Table, Loading },

    props: {
        columns: { type: Array, required: true },
        isLoading: { type: Boolean, default: false },
        isComplete: { type: Boolean, default: true },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardList {
    .status {
        margin: 25px;
        text-align: center;
    }

    .Loading {
        margin: 0 auto;
    }
}
</style>
